export function view(value) {
  return value.saving ? 'Saving' : value.isDirty ? 'Dirty' : 'No'
}
